'use client';

export { default } from './IconButton';
export { default as iconButtonClasses } from './iconButtonClasses';
export * from './iconButtonClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/IconButton/index.js
// module id = 193
// module chunks = 22